// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'opportunity-solid';

export const Component = () => (
  <path d='M4.922 6.89h16.092L23.935 1H2l2.921 5.89Zm8.046 16.092 3.64-7.232h-7.28l3.64 7.232Zm-4.119-8.237h8.238l3.4-6.849H5.448l3.4 6.849h.001Z' />
);

export const viewBox = '0 0 25 25';
